// material-ui
import { Button,  CardMedia, Stack, Typography } from '@mui/material';

// project-imports
import MainCard from 'components/MainCard';

// assets
import avatar from 'assets/images/users/customer-support-1.png';
import AnimateButton from 'components/@extended/AnimateButton';
import { useNavigate } from 'react-router-dom'; // ✅ Correct import for web routing
import { useCallback, useEffect,useState } from 'react';

const NavCard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({ name: '', email: '' });


 useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        setUser({ name: parsed[0].name, email: parsed[0].email });
      } catch (e) {
        console.error('Invalid user data in localStorage', e);
      }
    }
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('user'); // or sessionStorage, or your storage method
    navigate('/'); // redirect to login or home
  }, [navigate]);

  return (
    <MainCard sx={{ bgcolor: 'secondary.lighter', m: 3 }}>
      <Stack alignItems="center" spacing={2.5}>
        <CardMedia component="img" image={avatar} />
        <Stack alignItems="center">
          <Typography variant="h5">{user.name || 'User Name'}</Typography>
          <Typography variant="h6" color="secondary">
            {user.email || 'User Email'}
          </Typography>
        </Stack>
        <AnimateButton>
          <Button variant="shadow" size="small" onClick={handleLogout}>
            Logout
          </Button>
        </AnimateButton>
      </Stack>
    </MainCard>
  );
};

export default NavCard;
